export default __webpack_public_path__ + "images/icons/chevron-up-a13632f2d834efa166c7e3f24235e166.svg";